import { useQuery } from '@tanstack/react-query';
import { getBestOfProducts } from '@/data/bestOf';
import { BestOfCategory } from '@/contracts/bestOf';
import { useAuth } from '@/contexts/AuthContext';

/**
 * React Query hook for Best-Of category pages
 * Aggressive caching (10min staleTime) since rankings change infrequently
 */
export function useBestOfProducts(category: BestOfCategory | null) {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['best-of-products', category?.slug, user?.id],
    queryFn: () => {
      if (!category) throw new Error('Category required');
      return getBestOfProducts(category, user?.id);
    },
    enabled: !!category,
    staleTime: 1000 * 60 * 10, // 10 minutes
    gcTime: 1000 * 60 * 60, // 60 minutes
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}
